import { gql } from '@apollo/client';

export const USER_LOGIN = gql`
  query login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      role
    }
  }
`;

export const AUTH = gql`
  query AUTH($token: String) {
    auth(token: $token) {
      role
    }
  }
`;

export const GET_CURRENT_USER = gql`
  query getMyUser {
    getMyUser {
      name
      lastName
      email
      defaultCompany
    }
  }
`;
